module.exports = __webpack_public_path__ + "img/exam.a51191fe.svg";